export enum LabelSize {
  /** The size of the large label is 4x4 inches */
  Large = 'Large',
  /** The size of the small label is 3x3 inches */
  Small = 'Small',
}
